module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/012-sao-tome-and-prince-b2d344c64be36fc905f909ac51087749.svg";